import React from 'react'

import { List, ListElement } from './'

const LinksList = ({ header, info, links, footer, noBorders }) => (
	<List
		noBorders={noBorders}
		header={header}
		info={info}
		body={links.map((link, i) => {
			return <ListElement key={i} {...link} />
		})}
		footer={footer}
	/>
)

LinksList.propTypes = {
	links: React.PropTypes.array
}

export default LinksList



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/LinksList.js